import React from 'react';
import { makeStyles } from '@mui/styles';
import { compose } from '../../utils/compose';
import { withAuthorization } from '../Session';
import { withStyles } from '@mui/styles';
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import {gridSquareToLatLon} from './HamGridSquare'

const useStyles = makeStyles(theme => ({
}))

const MapPage = ( props ) => {

    const toLatLon = (coor) => { return {lat:coor[0], lng:coor[1] }}

    const markers = props.qsos.map((item)=>{
        if (item.GRID){
            try {
                let color = "red";
                if (item["MODE"] === "SSB")
                color = "green";
                if ((item["MODE"] === "FT8") || (item["MODE"] === "JT65"))
                color = "blue"
                if ((item["MODE"] === "PSK") || (item["MODE"] === "RTTY"))
                    color = "purple";
                return <Marker
                    title={item.CALL}
                    key={item.QSO_DATE+item.TIME_ON+item.CALL}
                    name={item.Call}
                    position={toLatLon(gridSquareToLatLon(item.GRID))}
                    icon={{ url:"http://maps.google.com/mapfiles/ms/icons/"+color+".png" }}
                />
            }
            catch(err){
                console.log(item.CALL, item.GRID, err)
                return null
            }

        }
        return null
    })
    return (<>
        <p>
        <img src="http://maps.google.com/mapfiles/ms/icons/green.png" height="16" alt=""/> Voice
        <img src="http://maps.google.com/mapfiles/ms/icons/blue.png" height="16" alt=""/> WSJT
        <img src="http://maps.google.com/mapfiles/ms/icons/purple.png" height="16" alt=""/> Digital
        <img src="http://maps.google.com/mapfiles/ms/icons/red.png" height="16" alt=""/> Other
        </p>
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        <Map
             style={{ width: '100%', height: '600px' }}
             defaultZoom={4}
             defaultCenter={{ lat: 32.397, lng: 34.644 }}
             >
        { markers }
        </Map>
        </APIProvider>
        </>
    )
}

const condition = authUser => !!authUser;

export default compose(
    withAuthorization(condition),
    withStyles(useStyles),
  )(MapPage);
    